import { ref } from 'vue'

class LoadingIndicatorHelperService {
  constructor() {}

  private isLoading = ref<boolean>(false)

  public showLoading(): void {
    this.isLoading.value = true
  }

  public hideLoading(): void {
    this.isLoading.value = false
  }

  public get loadingStatus() {
    return this.isLoading.value
  }
}
export default new LoadingIndicatorHelperService()
